function setIsMouse(): void {
  document.querySelector('html')?.classList.add('is-mouse');
  document.querySelector('html')?.classList.remove('is-keyboard');
}

function setIsKeyboard(): void {
  document.querySelector('html')?.classList.remove('is-mouse');
  document.querySelector('html')?.classList.add('is-keyboard');
}

export default function isMouse(): void {
  setIsMouse();
  window.addEventListener('mousedown', () => {
    setIsMouse();
  });
  window.addEventListener('keydown', (event) => {
    if (['Shift', 'Meta', 'Alt', 'Control'].indexOf(event.key) > -1) {
      return;
    }
    if (event.key !== 'Tab') {
      setIsMouse();
      return;
    }
    setIsKeyboard();
  });
}
